module.exports = (__webpack_require__(1))(79);


//////////////////
// WEBPACK FOOTER
// delegated ./lib/rlink-router/getCurrentRegion.js from dll-reference rlink_core
// module id = 574
// module chunks = 0